import React from 'react';
import { AGE_BANDS, CHAPTER_DEFINITIONS } from '../../../utils/childChapterUtils';

/**
 * Displays the current age band header, e.g. "Life Chapters — Ages 4-8"
 * with the first chapter's emoji as a visual accent.
 *
 * Props:
 *   band      - string key from AGE_BANDS (e.g. 'young_child')
 *   childName - display name of the child
 */
function ChildAgeBandLabel({ band, childName }) {
  const bandInfo = AGE_BANDS[band];
  if (!bandInfo) return null;

  const chapters = CHAPTER_DEFINITIONS[band] || [];
  const emoji = chapters.length > 0 ? chapters[0].emoji : '';

  return (
    <div className="mb-6">
      <h1 className="font-serif text-2xl sm:text-3xl text-[#556B2F] font-bold">
        {childName ? `${childName}'s Life Chapters` : 'Life Chapters'}
      </h1>
      <p className="mt-1 text-lg text-[#556B2F]/80">
        {bandInfo.label} &mdash; {bandInfo.description} {emoji}
      </p>
    </div>
  );
}

export default ChildAgeBandLabel;
